import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ typography }) =>
  createStyles({
    buttonContainer: {
      marginTop: '1rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.6rem',

      '& button': {
        width: '100%',
        height: '3.6rem',
        margin: 0,

        gap: '1rem',

        '&:last-child': {
          position: 'relative',

          '& > svg': {
            position: 'absolute',
            right: 16,
          },
        },
      },
    },
    paper: {
      width: '334px',

      '& > form': {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',

        '& > label': {
          margin: 0,

          '& .MuiTypography-body1': {
            fontSize: '1.4rem',
            fontFamily: typography.body2.fontFamily,
            fontWeight: 600,
          },
        },

        '& > button': {
          width: 'unset',
          maxHeight: '3.6rem',
          flex: 1,
          margin: '0.8rem 0.6rem',
        },
      },
    },
  }),
)
